import { db } from '../config/firebase'
import { collection, addDoc, query, orderBy, limit, getDocs, where } from 'firebase/firestore'

export async function saveScore(scoreData) {
  if (!scoreData || !scoreData.userId || scoreData.score === 0) {
    console.log('Score not saved: invalid data')
    return null
  }

  try {
    const userData = {
      userId: scoreData.userId,
      userName: scoreData.userName || 'Usuário Anônimo',
      userPhoto: scoreData.userPhoto || '',
      score: scoreData.score,
      level: scoreData.level || 1,
      lines: scoreData.lines || 0,
      game: scoreData.game || 'tetris',
      timestamp: new Date()
    }
    
    console.log('Saving score to Firebase:', userData)
    const docRef = await addDoc(collection(db, 'scores'), userData)
    console.log('Score saved successfully with ID:', docRef.id)
    
    return docRef.id
  } catch (error) {
    console.error('Error saving score:', error)
    throw error
  }
}

export async function loadGlobalRanking(gameName = null) {
  try {
    let globalQuery
    if (gameName) {
      globalQuery = query(
        collection(db, 'scores'),
        where('game', '==', gameName),
        orderBy('score', 'desc'),
        limit(50) // Pega mais para filtrar depois
      )
    } else {
      globalQuery = query(
        collection(db, 'scores'),
        orderBy('score', 'desc'),
        limit(50)
      )
    }
    const snapshot = await getDocs(globalQuery)
    const allScores = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
    
    // Remove duplicatas mantendo apenas o melhor score de cada usuário
    const uniqueScores = []
    const seenUsers = new Set()
    
    for (const score of allScores) {
      if (!seenUsers.has(score.userId)) {
        seenUsers.add(score.userId)
        uniqueScores.push(score)
      }
    }
    
    return uniqueScores.slice(0, 10)
  } catch (error) {
    console.error('Error loading global ranking:', error)
    return []
  }
}

export async function loadPersonalRanking(userId, gameName = null) {
  if (!userId) return []
  
  try {
    let personalQuery
    if (gameName) {
      personalQuery = query(
        collection(db, 'scores'),
        where('userId', '==', userId),
        where('game', '==', gameName),
        orderBy('score', 'desc'),
        limit(50) // Pega mais para filtrar
      )
    } else {
      personalQuery = query(
        collection(db, 'scores'),
        where('userId', '==', userId),
        orderBy('score', 'desc'),
        limit(50)
      )
    }
    const snapshot = await getDocs(personalQuery)
    const allScores = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
    
    // Remove scores duplicados (mesma pontuação)
    const uniqueScores = []
    const seenScores = new Set()
    
    for (const score of allScores) {
      if (!seenScores.has(score.score)) {
        seenScores.add(score.score)
        uniqueScores.push(score)
      }
    }
    
    return uniqueScores.slice(0, 10)
  } catch (error) {
    console.error('Error loading personal ranking:', error)
    return []
  }
}
